import sendDownloadEvent from "./_download";
import sendExternalEvent from "./_external";
import sendGaOn from "./_gaOn";
import sendInternalEvent from "./_internal";
import redact from "./_redact";

require("../../../../../../themes/custom/wwf/js/src/utilities/objectValuesPolyfill");

/**
 * Check whether this is a download URL or not.
 *
 * @param {string} url
 *   The web url to check.
 *
 * @return {boolean} isDownload
 */
const isDownload = (url) => {
  const regex = /^.*\.(jpg|JPG|gif|GIF|doc|DOC|pdf|PDF|zip)([?#]|$)/gim;
  const results = regex.exec(url.href);
  return results !== null;
};

/**
 * Check whether this is an external URL or not.
 *
 * @param {string} url
 *   The web url to check.
 *
 * @return {boolean} isDownload
 */
const isExternal = (url) => {
  return (
    url.hostname !== undefined && document.location.hostname !== url.hostname
  );
};

const isInternal = (url) => {
  if (url.hostname) {
    return url.hostname === document.location.hostname;
  }

  return false;
};

/**
 * Check whether the element has an on click event.
 *
 * @param {string} url
 *   The web url to check.
 *
 * @return {boolean} isDownload
 */
const isGaClick = (url) => {
  return url.hasAttribute("ga-on") && url.getAttribute("ga-on") === "click";
};

/**
 * Check whether this is an external URL or not.
 *
 * @param {string} url
 *   The web url to check.
 *
 * @return {boolean} isDownload
 */
const isGaSee = (url) => {
  return url.hasAttribute("ga-on") && url.getAttribute("ga-on") === "see";
};

const checkAnalytics = (url) => {
  if (isGaClick(url)) {
    sendGaOn(
      url.getAttribute("ga-event-category"),
      url.getAttribute("ga-event-action"),
      url.getAttribute("ga-event-label")
    );
  }

  if (isDownload(url)) {
    sendDownloadEvent(url);
  }

  if (isExternal(url)) {
    sendExternalEvent(url);
  }

  if (isInternal(url)) {
    sendInternalEvent(url);
  }
};

(() => {
  Drupal.behaviors.site_analytics = {
    attach: (context, settings) => {
      const pageAnchors = context.querySelectorAll("a");

      pageAnchors.forEach((value, index) => {
        value.addEventListener("click", (event) => {
          const url = event.currentTarget;
          checkAnalytics(url);
        });
      });

      const pageButtons = context.querySelectorAll("button");

      pageButtons.forEach((value, index) => {
        value.addEventListener("click", (event) => {
          const url = event.currentTarget;
          checkAnalytics(url);
        });
      });

      const images = context.querySelectorAll("img");

      images.forEach((value, index) => {
        value.addEventListener("click", (event) => {
          const url = event.currentTarget;
          if (isGaClick(url)) {
            sendGaOn(
              url.getAttribute("ga-event-category"),
              url.getAttribute("ga-event-action"),
              url.getAttribute("ga-event-label")
            );
          }
        });
      });

      const input = context.querySelectorAll("input");

      input.forEach((value, index) => {
        value.addEventListener("click", (event) => {
          const url = event.currentTarget;
          if (isGaClick(url)) {
            sendGaOn(
              url.getAttribute("ga-event-category"),
              url.getAttribute("ga-event-action"),
              url.getAttribute("ga-event-label")
            );
          }
        });
      });

      const gaOnEvents = context.querySelectorAll("[ga-on]");

      gaOnEvents.forEach((value) => {
        if (value.getAttribute("ga-on") === "see") {
          sendGaOn(
            value.getAttribute("ga-event-category"),
            value.getAttribute("ga-event-action"),
            value.getAttribute("ga-event-label")
          );
        }
      });
    },
  };
})();
